import { ErrorModal } from "@dexteel/mesf-core";
import { Grid, Paper, Typography, makeStyles } from "@material-ui/core";
import { useState } from "react";
import { Logbook } from "./components/Logbook";
import { useSearchEntries } from "./hooks/useSearchEntries";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .content-wrapper": {
			border: "none",
		},
	},
}));

export default function EntriesBrowser() {
	const classes = useStyles();
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [error, setError] = useState<string>("");

	const searchEntries = useSearchEntries({ setIsLoading, setError });

	return (
		<div style={{ display: "flex" }}>
			<Grid
				container
				className={classes.root}
				style={{ padding: 15, backgroundColor: "#F2F4F7" }}
			>
				<>
					<Grid item md={12} xs={12}>
						<Typography
							variant="h5"
							style={{
								fontWeight: 600,
								userSelect: "none",
								padding: 5,
							}}
						>
							Logbook
						</Typography>
					</Grid>
					<Logbook isLoading={isLoading} searchEntries={searchEntries} />
				</>
				<ErrorModal error={error} onHide={() => setError("")} />
			</Grid>
		</div>
	);
}
